import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { GetCommentsParams, GetCommentsResult } from "@/components/comment/actions/types";
import storageManager from "@/lib/storageManager";
import { Comment } from "@/models/comments";
import { RootState } from "@/reducers/types";

const HOME_COMMENT_SEARCH_PARAMS_KEY = "homeCommentSearchParams";

export const useHomeComment = (
  fetchData: (
    params: Pick<GetCommentsParams, "category_id" | "primary_charge_id" | "area_id" | "device_id">,
    callback?: (res: GetCommentsResult) => void
  ) => void
) => {
  const { masters } = useSelector((state: RootState) => state.construction);

  const [fetching, setFetching] = useState(true);
  const [comments, setComments] = useState<Comment[]>([]);

  const [categoryId, setCategoryId] = useState<number>();
  const [primaryChargeId, setPrimaryChargeId] = useState<number>();
  const [areaId, setAreaId] = useState<number>();
  const [deviceId, setDeviceId] = useState<number>();

  useEffect(() => {
    // 初期表示したときにローカルストレージに保存した条件がある場合は復元する
    const storedParams = storageManager.getConstructionItem(HOME_COMMENT_SEARCH_PARAMS_KEY);
    const params = storedParams ? JSON.parse(storedParams) : {};
    params?.category_id?.[0] && setCategoryId(params.category_id[0]);
    params?.primary_charge_id?.[0] && setPrimaryChargeId(params.primary_charge_id[0]);
    params?.area_id?.[0] && setAreaId(params.area_id[0]);
    params?.device_id?.[0] && setDeviceId(params.device_id[0]);

    search(params);
  }, []);

  // 検索条件の変更
  const changeCategory = (id: number) => {
    setCategoryId(id);
    search({ category_id: id ? [id] : [] });
  };
  const changePrimaryCharge = (id: number) => {
    setPrimaryChargeId(id);
    search({ primary_charge_id: id ? [id] : [] });
  };
  const changeArea = (id: number) => {
    setAreaId(id);
    search({ area_id: id ? [id] : [] });
  };
  const changeDevice = (id: number) => {
    setDeviceId(id);
    search({ device_id: id ? [id] : [] });
  };

  // 検索
  const search = (param: Pick<GetCommentsParams, "category_id" | "primary_charge_id" | "area_id" | "device_id">) => {
    setFetching(true);
    const params = {
      category_id: categoryId ? [categoryId] : undefined,
      primary_charge_id: primaryChargeId ? [primaryChargeId] : undefined,
      area_id: areaId ? [areaId] : undefined,
      device_id: deviceId ? [deviceId] : undefined,
      ...param,
    };
    storageManager.setConstructionItem(HOME_COMMENT_SEARCH_PARAMS_KEY, JSON.stringify({ ...params }));
    fetchData(params, (res) => {
      setComments(res.list);
      setFetching(false);
    });
  };

  return {
    fetching,
    categoryId,
    primaryChargeId,
    areaId,
    deviceId,
    changeCategory,
    changePrimaryCharge,
    changeArea,
    changeDevice,
    categories: masters?.categories ?? [],
    primaryCharges: masters?.primary_charges ?? [],
    areas: masters?.areas ?? [],
    devices: masters?.devices ?? [],

    comments,
  };
};
